import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { DocumentService } from 'src/app/services/document.service';
import { PaymentService } from '../../services/payment.service';
import { CommonModule } from '@angular/common';
import { filter, firstValueFrom, map, Observable, of, switchMap, take } from 'rxjs';
import { Router, RouterModule } from '@angular/router';
import { Timestamp } from '@angular/fire/firestore';
import {User} from 'src/app/models/user.model'
import { SubscriptionService } from 'src/app/services/subscription.service';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { RentalService } from 'src/app/services/rental.service';
import { Rental } from 'src/app/models/rental.model';
@Component({
  selector: 'app-dashboard-tenant',
  templateUrl: './dashboard-tenant.component.html',
  styleUrls: ['./dashboard-tenant.component.scss'],
  standalone: true,
  imports: [CommonModule,RouterModule]
})
export class DashboardTenantComponent implements OnInit {
  documents$: Observable<any[]>; // Declare as Observable
  payments$: Observable<any[]>;
  rental$: Observable<Rental>;
  user$!: Observable<User | null>;
  subscription$: Observable<any[]>;
  loading = true;
  user: User | null = null;
  constructor(
    public auth: AuthService,
    private documentService: DocumentService,
    private paymentService: PaymentService,
    private subscriptionService: SubscriptionService,
    private router: Router,
    private functions: Functions,
    private rentalService: RentalService
  ) {this.user$ = this.auth.user$;}

ngOnInit() {
    const uid = this.auth.firebaseUid; // <-- get UID from Firebase directly
    if (!uid) return;
    this.auth.user$.subscribe(u => {

      if (u === null) {
        // Firebase not ready yet — keep loading
        this.loading = true;
        return;
      }
      // Firebase loaded a real user
      this.user = u;
      this.rental$ = this.rentalService.getRentalById(u.rentalId);
      this.loading = false;
    });

    this.documents$ = this.documentService.getDocumentsByTenant(uid);
    this.payments$ = this.paymentService.getRecentPaymentsByTenant(uid).pipe(
      map(payments =>
        payments.map(p => {
          const date = this.normalizeDate(p.createdAt);
          const amountinCents = p.amount / 100;
          return {
            ...p,
            amountinCents,
            createdAtFormatted: this.formatDate(date),
          };
        })
      )
    );
    this.subscription$ = this.subscriptionService.getSubscriptionByTenant(uid);
  }
  downloadReceipt(url: string) {
    window.open(url, '_blank', 'noopener');
  }
  async cancelSubscription(subscriptionId: string) {
    console.log(subscriptionId)
   // this.subscriptionService.openBillingPortal(customerId).subscribe(console.log)
    this.subscriptionService.cancelSubscription(subscriptionId)
      .subscribe((res: any) => {
        window.location.href = res.url;
      });
  }

    private normalizeDate(input: any): Date | null {
    if (!input) return null;

    // Firestore Timestamp
    if (input instanceof Timestamp) return input.toDate();

    // Number timestamp
    if (typeof input === 'number') return new Date(input);

    // String timestamp (e.g. "November 18, 2025 at 1:30:06 PM UTC")
    if (typeof input === 'string') return new Date(input);

    // Fallback
    return null;
  }
  private formatDate(date: Date | null): string {
    if (!date) return '';

    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'long' });
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');

    // AM/PM formatting
    const period = hours >= 12 ? 'PM' : 'AM';
    const hour12 = hours % 12 || 12;

    // Ordinal suffix (1st, 2nd, 3rd, 4th, 11th, 12th...)
    const suffix =
      day >= 11 && day <= 13
        ? 'th'
        : ['st', 'nd', 'rd'][((day % 10) - 1)] || 'th';

    return `${month} ${day}${suffix}, ${year} ${hour12}:${minutes} ${period}`;
}
  // Track Lease By ID (Optimization for ngFor)
  trackDocument(index: number, document: any): string {
    return document.id;
  }
   // Navigate to Apply page
   goToDocuments() {
    this.router.navigate(['/tenant/documents']);
  }
goToPayments() {
    this.router.navigate(['/tenant/payments']);
  }

  // Navigate to Pay Rent page
  goToPay() {
    this.router.navigate(['/tenant/pay']);
  }
  goToSubscribe() {
    this.router.navigate(['/tenant/pay'], {
    queryParams: { type: 'recurring' }
  });
  }
  goToProfile() {
    this.router.navigate(['/tenant/profile']);
  }
  // Track Payment By ID (Optimization for ngFor)
  trackPayment(index: number, payment: any): string {
    return payment.id;
  }
}
